export const getSelectedMachine = (item) => {
    return  {
        type: "SELECTED_MACHINE",
        payload: item
    };
};
